export const tabMode = (state = "home", action) => {

    switch (action.type) {
      case 'TAB':
          return action.tab
        default:
          return state;
      }
  }
export const nameMode = (state = "", action) => {

    switch (action.type) {
      case 'NAME':
          return action
        default:
          return state;
      }
  }
export const detectHome = (state = true, action) => {

    switch (action.type) {
      case 'HOME':
          return action.isHome
        default:
          return state;
      }
  }
export const styleMode = (state = "", action) => {
    switch (action.type) {
      case 'STYLE':
          return action.style
        default:
          return state;
      }
  }
export const expandMode = (state = false, action) => {
  switch (action.type) {
    case 'SIDEBAR':
      return action.isExpand
      default:
        return state;
      }
    }
    export const networkMode = (state = true, action) => {
      switch (action.type) {
        case 'INTERNET':
          return action.internet
        default:
          return state;
      }
  }
export const setTitle = (state = "", action) => {
    switch (action.type) {
      case 'TITLE':
          return action.title
        default:
          return state;
      }
  }
export const setSocket = (state = null, action) => {
    switch (action.type) {
      case 'SOCKET':
          return action.socket
        default:
          return state;
      }
  }